export const contacts = {
  ADMIN_EMAIL: 'admin@youhelp.ru',
  EMAIL_FOR_ADVERT: 'advertising@youhelp.ru',
  EMAIL_FOR_CLAIMS: 'control@youhelp.ru',
  EMAIL_FOR_JOB_VACANCIES: 'vacancy@youhelp.ru',
  SUPPORT_PHONE: '78003017615',
  PHONE_FOR_CLAIMS: '74951285457',
  PHONE_FOR_JOB_VACANCIES: '79581119488',
} as const;
